import React from "react";
import { elementType, string, bool, oneOf } from "prop-types";
import Link from "../Link";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { sxClassName, sxProps, sxPropTypes } from "../props/sx";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const TabTitle = ({
	Tag = Link,
	tabType = 1,
	tabID = "",
	isAnchor = false,
	active = false,
	className,

	px = true,
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	...props
}) => {
	const ResultTag = active ? "span" : Tag;
	const anchor = isAnchor
		? {
				id: `${tabID}-tab`,
				href: `#${tabID}`,
		  }
		: {};
	return (
		<ResultTag
			data-toggle="tab"
			role="tab"
			aria-controls={tabID}
			aria-selected={active}
			className={classes(
				`tabs-v${tabType}__item`,
				active && `tabs-v${tabType}__item--active`,
				...utilityClassName(utility),
				...sxClassName(sx),
				...spacingClassName(deepMergeProps(px ? { md: { px: 10 } } : {}, pureProps(spacing))),
				className,
			)}
			{...anchor}
			{...props}
		/>
	);
};

TabTitle.propTypes = {
	Tag: elementType,
	tabID: string,
	tabType: oneOf([1, 2]),
	isAnchor: bool,
	active: bool,
	px: bool,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	spacing: spacingPropTypes,
	className: string,
};

export default TabTitle;
